export const backendToReactNationality: Record<string, string> = {
  deutsch: "Germany",
  che: "Switzerland",
  aut: "Austria",
  fra: "fra",
  ita: "ita",
  aus: "aus",
  "shqiptare/albanian": "shqiptare/albanian",
  bel: "bel",
  "bih/бих": "bih/бих",
  "българия/bg": "българия/bgr",
  bra: "bra",
  mne: "mne",
  "česká republika": "česká republika",
  dnk: "dnk",
  est: "est",
  fin: "fin",
  "ελληνикΗ/hellenic": "ελληνикΗ/hellenic",
  nederlandse: "nederlandse",
  hrv: "hrv",
  "éireannach/irish": "IRL",
  kosovar: "kosovar",
  latvijas: "latvijas",
  "lietuvos respublikos": "lietuvos respublikos",
  lux: "lux",
  hun: "hun",
  mda: "mda",
  "norsk/norwegian": "norsk/norwegian",
  polskie: "polskie",
  prt: "prt",
  rou: "rou",
  "македонско/macedonian": "македонско/macedonian",
  esp: "esp",
  "република србија/republic of serbia": "Serbia",
  svk: "svk",
  si: "si",
  "svensk/swe": "svensk/swe",
  україна: "Ukraine",
  irq: "irq",
  chn: "chn",
  are: "are",
  geo: "geo",
  mex: "mex"
};

export function mapBackendNationality(code: string): string|null {
  if (!code) return null
  const normalized = code.trim().toLowerCase();
  return backendToReactNationality[normalized] ?? code;
}